import './styles.styl'
import 'react-toggle/style.css'

import React from 'react'
// import Autocomplete from 'react-autocomplete'
// import Toggle from 'react-toggle'

export default class SettingsBudget extends React.Component {
  constructor (props) {
    super(props)

    let state = {}

    if (props.data !== null) {
      state = {
        ...state,
        ...props.data
      }
    }

    this.state = state
  }

  slugify (text) {
    return String(text)
      .toLowerCase()
      .replace(/\s+/g, '-') // Replace spaces with -
      .replace(/[^\w-]+/g, '') // Remove all non-word chars
      .replace(/--+/g, '-') // Replace multiple - with single -
      .replace(/^-+/, '') // Trim - from start of text
      .replace(/-+$/, '') // Trim - from end of text
  }

  saveAndToggle (index) {
    this.props.save({ ...this.state })
    this.props.toggleSection(index)
  }

  saveAndNext (index) {
    this.props.save({ ...this.state })
    this.props.nextSection(index)
  }

  render () {
    const index = this.props.index
    let content = null

    if (this.props.active === false) {
      content = <em>Als het project budgetten gebruikt, kun je die hier importeren.</em>
    } else {
      content = (
        <div key={1} className='row subsection'>
          <div className='col-12 col-sm-4'>
            <label className='form-label'>Budgetten importeren</label>
          </div>

          <div className='col-12 col-sm-8'>
            <input
              type='file'
              className='form-control-file form-control-sm'
              placeholder='Selecteer een CSV bestand.'
            />
          </div>
        </div>
      )
    }

    return (
      <section key={index} className={['section', (this.props.open ? 'section-open' : 'section-closed')].join(' ')}>
        <div className='row section-title'>
          <div className='col-10'>
            <h3>Budgetten</h3>
          </div>

          <div className='col-2 text-align-right'>
            <a href='#' onClick={() => this.saveAndToggle(index)} className='edit-link'>{this.props.open ? 'Sluiten' : 'Bewerken'}</a>
          </div>
        </div>

        <div className='row section-content'>
          <div className='col-12 col-lg-10'>
            {content}
          </div>
        </div>

        <div className='row section-buttons'>
          <div className='col-12 text-align-right'>
            <button className='btn btn-sm btn-secondary btn-rounded' onClick={() => this.saveAndNext(index)}>Volgende &raquo;</button>
          </div>
        </div>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./ui/projects/create/settings-budget.js